import script from "./OffersView.vue?vue&type=script&setup=true&lang=js"
export * from "./OffersView.vue?vue&type=script&setup=true&lang=js"

import "./OffersView.vue?vue&type=style&index=0&id=3cdad912&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cdad912"]])

export default __exports__